import PropTypes from 'prop-types';

import { stepsFactory } from 'components/Booking-new/utils/steps';

import WaitlistDataContainer from './WaitlistDataContainer';
import VariantA from './Variants/VariantA';

const waitlistVariants = {
  a: VariantA,
};

const WaitlistData = ({ variant, data, navigation, userData }) => {
  return stepsFactory(waitlistVariants, variant, { data, navigation, userData }, WaitlistDataContainer);
};

WaitlistData.propTypes = {
  variant: PropTypes.oneOf(['a']).isRequired,
  data: PropTypes.object.isRequired,
  navigation: PropTypes.object.isRequired,
  userData: PropTypes.object,
};
export default WaitlistData;
